import React from "react";
import proj1 from "../assets/proj1.png";
import proj2 from "../assets/proj2.png";
import proj3 from "../assets/proj3.png";
import proj4 from "../assets/proj4_color_gradient.png"
import proj5 from "../assets/proj5_Amaone_Clone.png"
import proj6 from "../assets/Proj6_To_do_list.png"
import proj7 from "../assets/proj7_Clock.png"
import proj8 from "../assets/Proj8_timer.png"
import proj9 from "../assets/proj9_dicegame.png"
import proj10 from "../assets/proj10.png"
import react1 from "../assets/Tubehub.png"
import netflix from "../assets/Netflix.png"


const Portfolio = () => {
  const projs = [
    {
      id: 1,
      project: netflix,
      name: "Netflix",
      href1: "https://playflixclone.netlify.app/",
      href2: "https://github.com/likhitharai/netflix",
      technology1:"#React",
      technology2:"#JavaScript",
      technology3:"#Tailwindcss",
      description:"Introducing a Netflix clone crafted with React and powered by the TMDB API. Use credentials - Admin@gmail.com & Admin@123 and do checkout some movie recommendations!"
    },
    {
      id: 2,
      project: react1,
      name: "Tubehub",
      href1: "https://tubehub1.netlify.app/",
      href2: "https://github.com/likhitharai/Productivity_app_completed",
      technology1:"#React",
      technology2:"#JavaScript",
      technology3:"#Tailwindcss",
      description:"Welcome to TubeHub, your new go-to platform for all things video! Built with React and powered by the YouTube API, TubeHub offers a dynamic video experience. Discover and watch your favorite content."
    },
    {
      id: 3,
      project: proj1,
      name: "Productivity app",
      href1: "https://likhitharai.github.io/prod/",
      href2: "https://github.com/likhitharai/Productivity_app_completed",
      technology1:"#HTML",
      technology2:"#CSS",
      technology3:"#JavaScript",
      description:"Introducing TaskTrek, a sleek and efficient productivity app crafted with HTML, CSS, and JavaScript to streamline your daily tasks and keep you organized."
    },
    {
      id: 4,
      project: proj2,
      name: "Weather app",
      href1: "https://likhitharai.github.io/Weather-App/",
      href2: "https://github.com/likhitharai/Weather-App",
      technology1:"#HTML",
      technology2:"#CSS",
      technology3:"#JavaScript",
      description:"The weather app project is a dynamic web application designed to provide users with real-time weather updates and forecasts based on their location by utilizing APIs."
    },
    {
      id: 5,
      project: proj3,
      name: "Drumkit game",
      href1: "https://likhitharai.github.io/Interacrive_drum_kit/",
      href2: "https://github.com/likhitharai/Interacrive_drum_kit",
      technology1:"#HTML",
      technology2:"#CSS",
      technology3:"#JavaScript",
      description:"The drumkit project is an interactive web application that simulates a virtual drum set, allowing users to produce sounds by clicking on corresponding keys or tapping keys on their keyboard and mouse clicks."
    },
    {
      id: 6,
      project: proj4,
      name: "Gradient Color Picker",
      href1: "https://likhitharai.github.io/gradient/",
      href2: "https://github.com/likhitharai/gradient",
      technology1:"#HTML",
      technology2:"#CSS",
      technology3:"#JavaScript",
      description:"The Gradient Color Picker allows users to generate and customize gradient colors for web design projects. It enables preview and selection of gradients, catering to designers seeking visually appealing color schemes."
    },
    {
      id: 7,
      project: proj5,
      name: "Amazone Clone- UI",
      href1: "https://likhitharai.github.io/Amazone_clone/",
      href2: "https://github.com/likhitharai/Amazone_clone",
      technology1:"#HTML",
      technology2:"#CSS",
      description:"The purpose of the Amazon Clone is to provide a learning tool for HTML and CSS developers to practice their skills in building responsive web interfaces, by replicating the design e-commerce website - Amazon"
    },
    {
      id: 8,
      project: proj6,
      name: "To-Do-List",
      href1: "https://likhitharai.github.io/todolist_yellow/",
      href2: "https://github.com/likhitharai/todolist_yellow",
      technology1:"#HTML",
      technology2:"#CSS",
      technology3:"#JavaScript",
      description:"The purpose of the Amazon Clone is to provide a learning tool for HTML and CSS developers to practice their skills in building responsive web interfaces, by replicating the design e-commerce website - Amazon"
    },
    {
      id: 9,
      project: proj7,
      name: "Real-Time Clock",
      href1: "https://likhitharai.github.io/Clock_yellow/",
      href2: "https://github.com/likhitharai/Clock_yellow",
      technology1:"#HTML",
      technology2:"#CSS",
      technology3:"#JavaScript",
      description:"The purpose of the Amazon Clone is to provide a learning tool for HTML and CSS developers to practice their skills in building responsive web interfaces, by replicating the design e-commerce website - Amazon"
    },
    {
      id: 10,
      project: proj8,
      name: "Timer",
      href1: "https://likhitharai.github.io/Timer/",
      href2: "https://github.com/likhitharai/Timer",
      technology1:"#HTML",
      technology2:"#CSS",
      technology3:"#JavaScript",
      description:"TIMER is a sleek, user-friendly project designed with HTML, CSS, and JavaScript to accurately capture and display elapsed time. Its intuitive interface allows users to effortlessly track durations."
    },
    {
      id: 11,
      project: proj9,
      name: "Dice Game",
      href1: "https://likhitharai.github.io/dice_game/",
      href2: "https://github.com/likhitharai/dice_game",
      technology1:"#HTML",
      technology2:"#CSS",
      technology3:"#JavaScript",
      description:"Dice Roll is a simple game built with JavaScript that randomly decides a winner each time the page is refreshed. Players are represented by virtual dice, and with every reload, the dice roll to reveal a winner."
    },
    {
      id: 12,
      project: proj10,
      name: "Rock paper scissors",
      href1: "https://likhitharai.github.io/Rock_paper_scissors_shoot/",
      href2: "https://github.com/likhitharai/Rock_paper_scissors_shoot",
      technology1:"#HTML",
      technology2:"#CSS",
      technology3:"#JavaScript",
      description:"This interactive Rock, Paper, Scissors game brings the classic hand game to life with a modern web interface. Built using HTML, CSS, and JavaScript, the game features a clean and responsive design that allows players to easily select their choice with intuitive buttons."
    },
  ];

  return (
    <div className="max-w-[1200px] mx-auto p-5" id="portfolio">
      <div className="pb-8">
        <p className="text-4xl mb-3 font-bold primary-color">Portfolio</p>
        <p className="text-gray-400">Check out my recent work <br />(Hover on the card to view the link to demo and source code)</p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
        {projs.map(({ id, name, project, href1, href2, technology1, technology2, technology3, description}) => (
          /* My class */
          <div className="bg-gray-800 h-[450px] max-w-sm rounded overflow-hidden shadow-lg">
            <div
              key={id}
              className="transform transition-transform  duration-300 hover:scale-105 overflow-hidden shadow-lg shadow-[$040c16]
            group rounded-md flex justify-center items-center mx-auto content-div h-[200px] bg-cover relative"
            >
              <img src={project} alt="My first project" />

              <div className="opacity-0 group-hover:opacity-90 bg-[gray]/70 absolute inset-0 flex flex-col justify-center items-center">
                <span className="text-2xl font-bold text-white tracking-wider"></span>

                <div className="pt-8 text-center">
                  <a href={href1} target="_blank" rel="noreferrer">
                    <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                      Live demo
                    </button>
                  </a>
                  <a href={href2}>
                    <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                      Source code
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div class="px-6 py-4">
              <div class="font-bold text-xl mb-2 text-gray-400">{name}</div>
              <p class="text-white text-base">
                {description}
              </p>
            </div>


            <div class="px-6 pt-4 pb-2">
    <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">{technology1}</span>
    <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">{technology2}</span>
    <span class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">{technology3}</span>
  </div>

          </div>
        ))}

      </div>
    </div>
  );
};

export default Portfolio;
